import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { getEntities } from 'dash-front/selectors';
import { fetchOdds, oddNameSelector, oddsSelection } from './actions';
import { TimeElapsed } from './TimeElapsed';
import { marketDisplayName } from './constants';
import { OutcomeItem } from './OutcomeItem';

const marketContainerStyle = {
    display: 'flex',
    flexWrap: 'wrap'
};

const BetOffer = connect((state, { id }) => ({ betOffer: get(getEntities(state).betOffers, id) }))(
    ({ betOffer, ...rest }) => {
        return betOffer ? (
            <div style={marketContainerStyle}>
                {betOffer.outcomes.map(id => <OutcomeItem {...rest} key={id} id={id} />)}
            </div>
        ) : null;
    }
);

export const MarketItem = connect((state, { eventId, market }) => {
    const provider = oddsSelection.select(state).selectedProvider;
    const oddPath = oddNameSelector(eventId, market, provider);
    const { events, odds } = getEntities(state);

    return {
        provider,
        event: get(events, eventId),
        oddsObject: get(odds, oddPath)
    };
})(
    class extends React.Component {
        componentDidMount() {
            const { eventId, market, provider } = this.props;
            this.updateOutcomes({ eventId, market, provider });
        }

        componentWillReceiveProps({ eventId, market, provider }) {
            if (this.props.eventId !== eventId || this.props.market !== market || this.props.provider !== provider) {
                this.updateOutcomes({ eventId, market, provider });
            }
        }

        state = {};

        updateOutcomes({ eventId, market, provider }) {
            if (provider && typeof provider !== 'symbol') {
                this.props.dispatch(fetchOdds(eventId, market, provider));
            }
        }

        renderHeader() {
            const { market } = this.props;
            const date = get(this.props.oddsObject, 'lastUpdateAt');
            const displayName = marketDisplayName[market] || market;
            return (
                <p style={{ background: '#ccc', display: 'flex', justifyContent: 'space-between' }}>
                    {displayName}{' '}
                    {date && (
                        <span>
                            Updated: <TimeElapsed date={date} />
                        </span>
                    )}
                </p>
            );
        }

        renderContent() {
            const { oddsObject, eventId } = this.props;
            const betOffers = oddsObject && oddsObject.betOffers;
            return Array.isArray(betOffers) && betOffers.length ? (
                <div style={marketContainerStyle}>
                    {betOffers.map(betOffer => (
                        <div key={betOffer} style={{ ...marketContainerStyle, width: '100%' }}>
                            <BetOffer id={betOffer} eventId={eventId} />
                        </div>
                    ))}
                </div>
            ) : (
                <p>No odds</p>
            );
        }

        render() {
            const { oddsObject } = this.props;
            if (!oddsObject) {
                return null;
            }
            return (
                <div>
                    {this.renderHeader()}
                    {this.renderContent()}
                </div>
            );
        }
    }
);

MarketItem.propTypes = {
    disabled: PropTypes.bool,
    market: PropTypes.string.isRequired,
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/odds/MarketItem.js
 **/